import xlsxExport from '../../shared/xlsxExport/xlsxExport';

import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';

export default ({
  reportTitle,
  reportData,
  description,
  fileName,
  hideDecimals = false,
  shouldDisplayZero,
  negativeMinus,
  descriptionColumnIndex,
}) => {
  const sheetData = [
    {
      name: 'GAAP',
      data: reportData.GAAP,
      type: SheetExportTypes.REPORT,
      descriptionColumnIndex,
      options: {
        numberOfAdditionalRowsToStick: 2,
        hideDecimals,
        shouldDisplayZero,
        negativeMinus,
      },
    },
    {
      name: 'GAAP to STAT',
      data: reportData.GAAP_TO_STAT,
      type: SheetExportTypes.REPORT,
      descriptionColumnIndex,
      options: {
        numberOfAdditionalRowsToStick: 2,
        hideDecimals,
        shouldDisplayZero,
        negativeMinus,
      },
    },
    {
      name: 'STAT',
      data: reportData.STAT,
      type: SheetExportTypes.REPORT,
      descriptionColumnIndex,
      options: {
        numberOfAdditionalRowsToStick: 2,
        hideDecimals,
        shouldDisplayZero,
        negativeMinus,
      },
    },
    ...(reportData.ALL ? [{
      name: 'ALL',
      data: reportData.ALL,
      type: SheetExportTypes.REPORT,
      descriptionColumnIndex,
      options: {
        numberOfAdditionalRowsToStick: 2,
        hideDecimals,
        shouldDisplayZero,
        negativeMinus,
      },
    }] : []),
  ]
    .filter(sheet => sheet.data);

  xlsxExport({
    sheetData,
    metadata: {
      reportTitle,
      description,
      fileName,
    },
  });
};
